import React, { useEffect, useRef, useState } from 'react';
import { Card, Button, Table } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import useApi from '../../Api';
import { toast } from 'react-toastify';
import '../../styles/pages/Admin/AdminBlogOriginsPage.css';

const AdminBlogOriginsPage = () => {
  const [blogOrigins, setBlogOrigins] = useState([]);
  const [isTriggering, setIsTriggering] = useState(false);
  const apiClient = useApi();
  const hasFetched = useRef(false);

  const fetchBlogOrigins = async () => {
    try {
      const response = await apiClient.get('/admin/blog-origins');
      setBlogOrigins(response.data);
    } catch (error) {
      toast.error(
        error.response?.data?.detail || 'Failed to fetch blog origins.',
        {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  };

  const triggerAggregation = async () => {
    if (isTriggering) return;
    setIsTriggering(true);
    try {
      await apiClient.post('/admin/blog-origins/trigger');
      toast.success('Blog aggregation triggered successfully.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      await fetchBlogOrigins();
    } catch (error) {
      toast.error(
        error.response?.data?.detail || 'Failed to trigger blog aggregation.',
        {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    } finally {
      setIsTriggering(false);
    }
  };

  useEffect(() => {
    if (!hasFetched.current) {
      fetchBlogOrigins();
      hasFetched.current = true;
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>WeiFinders Admin Blog Origins</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="admin-blog-origins-div">
        <Card className="admin-blog-origins-card">
          <Card.Body>
            <h2 className="admin-blog-origins-title">Blog Origins</h2>
            <Button
              variant="primary"
              className="admin-button"
              onClick={triggerAggregation}
              disabled={isTriggering}
            >
              {isTriggering ? 'Processing...' : 'Trigger Blog Aggregation'}
            </Button>
            <Table striped bordered hover className="admin-blog-origins-table">
              <thead>
                <tr>
                  <th>Origin ID</th>
                  <th>Origin Name</th>
                  <th>Number of Blogs</th>
                  <th>Latitude</th>
                  <th>Longitude</th>
                </tr>
              </thead>
              <tbody>
                {blogOrigins.map(origin => (
                  <tr key={origin.origin_id}>
                    <td>{origin.origin_id}</td>
                    <td>{origin.origin_name}</td>
                    <td>{origin.number_of_blogs}</td>
                    <td>{origin.latitude}</td>
                    <td>{origin.longitude}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default AdminBlogOriginsPage;
